import React, { memo, type ReactNode } from 'react';
import type { MenuViewModel } from 'autogen/swagger/all';
import DefaultContentRenderer from 'components/generic/Drawer/components/DefaultContentRenderer';
import { StyledDrawerView } from '../../../shared/styles';
import SideMenu from '../SideMenu';
import MenuHeader from './MenuHeader';
import MenuSkeleton from './MenuSkeleton';

type HeaderProps = {
    backButtonCallback: MenuWithHeaderProps['backButtonCallback'];
    headline: MenuViewModel['headline'];
    headerLinks?: MenuViewModel['headerLinks'];
    styling?: MenuViewModel['styling'];
};

type MenuWithHeaderProps = {
    drawerId: string;
    menu?: MenuViewModel;
    backButtonCallback?: () => void;
    isLoading?: boolean;
    animate?: boolean;
    headerRenderer?: (headerProps: HeaderProps) => ReactNode;
};

const MenuWithHeader = ({
    drawerId,
    menu,
    backButtonCallback,
    isLoading,
    animate,
    headerRenderer = (headerProps) => <MenuHeader {...headerProps} />
}: MenuWithHeaderProps) => {
    const { headline, headerLinks, styling } = menu || {};

    return (
        <StyledDrawerView
            id={drawerId}
            animate={animate}
            position="left"
            fullscreen
            contentRenderer={(contentProps) => <DefaultContentRenderer.NoPadding {...contentProps} />}
            headerRenderer={() => headerRenderer({ backButtonCallback, headline, headerLinks, styling })}
        >
            {isLoading || !menu || !menu.sections.length ? <MenuSkeleton /> : <SideMenu menu={menu} />}
        </StyledDrawerView>
    );
};

export default memo(MenuWithHeader);
